import React from "react";

// Minimal line-icon set. Stroke inherits currentColor.
const paths = {
  wardrobe: (
    <>
      <rect x="4" y="3" width="16" height="18" rx="1" />
      <path d="M12 3v18" />
      <path d="M10 11h.01M14 11h.01" />
    </>
  ),
  kitchen: (
    <>
      <rect x="3" y="4" width="18" height="6" rx="1" />
      <rect x="3" y="14" width="18" height="6" rx="1" />
      <path d="M8 4v6M8 14v6" />
    </>
  ),
  door: (
    <>
      <path d="M5 21V4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v17" />
      <path d="M3 21h18" />
      <path d="M13 12h.01" />
    </>
  ),
  deck: (
    <>
      <path d="M3 8h18M3 8l2-4h14l2 4M4 8v12M20 8v12M9 8v12M15 8v12" />
    </>
  ),
  roof: (
    <>
      <path d="M2 12 12 4l10 8" />
      <path d="M12 4v16M6 8.8V20M18 8.8V20M2 12l10 8 10-8" />
    </>
  ),
  building: (
    <>
      <path d="M3 21V8l7-5 7 5v13" />
      <path d="M3 21h18" />
      <path d="M8 21v-5h4v5" />
      <path d="M17 21V11l4 3v7" />
    </>
  ),
  stairs: (
    <>
      <path d="M3 20h4v-4h4v-4h4V8h4V4" />
    </>
  ),
  compass: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="m15 9-3.5 5.5L9 15l3.5-5.5L15 9Z" />
    </>
  ),
  quote: (
    <>
      <path d="M20 6 9 17l-5-5" />
    </>
  ),
  shield: (
    <>
      <path d="M12 3 5 6v6c0 4 3 6.5 7 9 4-2.5 7-5 7-9V6l-7-3Z" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </>
  ),
  phone: (
    <>
      <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L20 13l1 4v2a1 1 0 0 1-1 1A16 16 0 0 1 4 5a1 1 0 0 1 1-1Z" />
    </>
  ),
  mail: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m3 7 9 6 9-6" />
    </>
  ),
  pin: (
    <>
      <path d="M12 21s7-5.5 7-11a7 7 0 1 0-14 0c0 5.5 7 11 7 11Z" />
      <circle cx="12" cy="10" r="2.5" />
    </>
  ),
};

export default function Icon({ name, className = "w-6 h-6", strokeWidth = 1.6 }) {
  const content = paths[name];
  if (!content) return null;
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {content}
    </svg>
  );
}
